import React, { useState } from "react";
import "./MenuSection.css";
import { Modal } from "react-bootstrap";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';

const MenuSection = () => {
  const [showModal, setShowModal] = useState(false);

  const pdfUrl = "/assets/images/about_us/menuSection/menucard.pdf";

  return (
    <>
      <section className="about-menu-section">
        <div className="about-menu-section__container">
          <div className="row align-items-center">
            {/* LEFT CONTENT */}
            <div className="col-lg-6">
              <div className="about-menu-section__content">
                <h2>Our Food Menu</h2>
                <p>
                  Enjoy authentic Malvani cuisine prepared with fresh local
                  ingredients. Our menu includes delicious egg dishes, fish
                  starters, soups, and traditional meals that enhance your
                  peaceful stay at Jaltaara Resort.
                </p>

                <ul>
                  <li>Fresh & Hygienic Food</li>
                  <li>Authentic Malvani Taste</li>
                  <li>Veg & Non-Veg Options</li>
                  <li>Room Service Available</li>
                </ul>
              </div>
            </div>

            {/* RIGHT IMAGES */}
            <div className="col-lg-6">
              <div className="pdf_wrapper_holder">
                <div className="row justify-content-center">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div
                      className="menuImageBox"
                      onClick={() => setShowModal(true)}
                    >
                      <img
                        src="/assets/images/about_us/menuSection/menu_img_1.webp"
                        alt="Menu"
                        className="menu_card_img"
                      />
                      <div className="menuOverlay">
                        <span>View Menu</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PDF MODAL */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        scrollable
        className="menu_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Food Menu</Modal.Title>
        </Modal.Header>

        <Modal.Body className="pdf-modal-body">
            <div className="img_holder">
              <>
              {" "}
              <img
                src="/assets/images/about_us/menuSection/menu_img_1.webp"
                alt="Menu"
                className="menu_card_img"
              />
              {" "}
              <img
                src="/assets/images/about_us/menuSection/menu_img_2.webp"
                alt="Menu"
                className="menu_card_img"
              />
              </>
            </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MenuSection;
